import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { getRequest } from '../../requestUtils';
import searchIcon from '../../../assets/images/search-icon-white.svg';
import RecommendedConsultantCard from '../RecommendedConsultantCard';
import Loading from '../common/Loading';
import './ConsultantSearchContainer.scss';
function ConsultantSearchContainer(_ref) {
  var initialConsultants = _ref.consultants,
    searchUrl = _ref.searchUrl,
    csrfToken = _ref.csrfToken,
    email = _ref.email,
    cloraEmployer = _ref.cloraEmployer,
    googleOmniauthUrl = _ref.googleOmniauthUrl,
    msOmniauthUrl = _ref.msOmniauthUrl,
    signInUrl = _ref.signInUrl;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchQuery = _useState2[0],
    setSearchQuery = _useState2[1];
  var _useState3 = useState(initialConsultants),
    _useState4 = _slicedToArray(_useState3, 2),
    consultants = _useState4[0],
    setConsultants = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSearching = _useState6[0],
    setIsSearching = _useState6[1];
  var handleSearch = useCallback(function () {
    if (!searchQuery.trim()) return;
    setIsSearching(true);
    getRequest("".concat(searchUrl, "?query=").concat(encodeURIComponent(searchQuery)), csrfToken).then(function (_ref2) {
      var data = _ref2.data;
      setConsultants(data);
      setIsSearching(false);
    })["catch"](function () {
      return setIsSearching(false);
    });
  }, [searchQuery, searchUrl, csrfToken]);
  var handleClearSearchInput = function handleClearSearchInput() {
    setSearchQuery('');
    setConsultants([]);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "consultant-search-container d-flex flex-column w-100 h-100 p-3 gap-4 rounded-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "search-header d-flex flex-column w-100 h-100 p-5 gap-4 rounded-3"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-center mb-3"
  }, "Consultant Search"), /*#__PURE__*/React.createElement("div", {
    className: "input-with-symbol"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    onChange: function onChange(e) {
      return setSearchQuery(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') handleSearch();
    },
    value: searchQuery,
    placeholder: "Enter search query"
  }), searchQuery && /*#__PURE__*/React.createElement("i", {
    className: "fa fa-times clear-btn",
    role: "button",
    tabIndex: 0,
    onClick: handleClearSearchInput
  }), /*#__PURE__*/React.createElement("span", {
    role: "button",
    tabIndex: 0,
    onClick: handleSearch,
    disabled: !searchQuery.trim()
  }, /*#__PURE__*/React.createElement("img", {
    src: searchIcon,
    alt: "search icon"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "search-results d-flex flex-column justify-content-center w-100 h-100 gap-4 rounded-3"
  }, isSearching ? /*#__PURE__*/React.createElement(Loading, null) : consultants.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "cards mb-3 justify-content-center gap-3"
  }, consultants.map(function (consultant) {
    return /*#__PURE__*/React.createElement(RecommendedConsultantCard, {
      consultant: consultant,
      getEmailStatus: function getEmailStatus() {
        return email;
      },
      csrfToken: csrfToken,
      cloraEmployer: cloraEmployer,
      googleOmniauthUrl: googleOmniauthUrl,
      msOmniauthUrl: msOmniauthUrl,
      signInUrl: signInUrl
    });
  })) : /*#__PURE__*/React.createElement("div", {
    className: "no-results text-center bg-white rounded-3 p-5 fs-5"
  }, "Enter a search query to begin searching.")));
}
ConsultantSearchContainer.propTypes = {
  consultants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  showProjectEmploymentType: PropTypes.bool,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired
};
export default ConsultantSearchContainer;